import PropTypes from 'prop-types'
import React, { useState, useEffect } from 'react'
import MetaTags from 'react-meta-tags'
import { Container, Row, Col, Label } from 'reactstrap'

import { Loading } from '../../components/Loading'
import { toast } from 'react-toastify'
import DatatableTables from '../../components/Table'

import 'chartist/dist/scss/chartist.scss'
import { formatDateT } from '../../util/string'
import styles from './styles.module.scss'
import { CardIndicador } from '../../components/CardIndicador'
import Services from '../../services/sendMessage'
import { formatToBrazillianDateDayMonth, validarData } from 'util/function'
import { PageHeader } from 'components/pageHeader'
import { SectionCard } from '../EnviarPlanilha/components/SectionCard'
import { SelectComponent } from 'components/selectComponent'
import { Form, Button } from 'react-bootstrap'
import ReactDatePicker, { registerLocale } from 'react-datepicker'
import { format } from 'date-fns'
import ptBR from 'date-fns/locale/pt-BR'

registerLocale('pt-BR', ptBR)

const columns = [
  { label: 'Id', field: 'id' },
  { label: 'Data', field: 'created_at' },
  { label: 'Campanha', field: 'name' },
  { label: 'Instância', field: 'nameInstancia' },
  { label: 'Tipo', field: 'type' },
  { label: 'Status', field: 'status', html: true },
  { label: 'N° Total', field: 'messageTotal' },
  { label: 'Enviadas', field: 'messageSent', html: true },
  { label: 'Recebidas', field: 'messageReceived', html: true },
  { label: 'Lidas', field: 'messageRead', html: true }
]

const Dashboard = () => {
  const [loading, setLoading] = useState(false)
  const [data, setData] = useState([])
  const [rows, setRows] = useState([])
  const [instanciasList, setInstanciasList] = useState([])
  const [rendered, setRendered] = useState(false)

  const [valueDatePicker, setValueDatePicker] = useState({
    startsAt: null,
    endsAt: null
  })

  const [tableConfig, setTableConfig] = useState({
    options: {
      collapse: false,
      order: true,
      more: false,
      pagination: true,
      resendPurchase: true,
      createCheckout: localStorage.getItem('root@session')
    },
    config: {
      resendPurchaseText: 'Reenviar Qr codes da compra'
    },
    filters: {
      instanceId: null,
      endsAt: null,
      startsAt: null
    },
    total: 0,
    currentPage: 0,
    rowsPerPage: 20
  })

  const loadIndicators = async () => {
    setLoading(true)
    const response = await Services.loadIndicators({
      rowsPerPage: tableConfig.rowsPerPage,
      page: tableConfig.currentPage,
      instanceId: tableConfig.filters.instanceId,
      startsAt: tableConfig.filters.startsAt,
      endsAt: tableConfig.filters.endsAt
    })

    if (response.status === 200) {
      const now = new Date().getTime()
      const resume = response?.data?.data?.campanhaList.map((item) => {
        let sendDate = {
          string: null,
          timestamp: null
        }

        if (item.horaEnvio && validarData(item.horaEnvio)) {
          sendDate = {
            string: formatToBrazillianDateDayMonth(item.horaEnvio),
            timestamp: new Date(item.horaEnvio).getTime()
          }
        }

        const SI = '<span style="color: red">---</span>'

        const percMessageRead =
          (item.messageRead * 100) / item.messageTotal < 1
            ? SI
            : `${((item.messageRead * 100) / item.messageTotal).toFixed(2)}%`

        const percMessageSent =
          (item.messageSent * 100) / item.messageTotal === 0
            ? SI
            : `${((item.messageSent * 100) / item.messageTotal).toFixed(2)}%`

        const percMessageReceived =
          (item.messageReceived * 100) / item.messageTotal === 0
            ? SI
            : `${((item.messageReceived * 100) / item.messageTotal).toFixed(
                2
              )}%`

        return {
          ...item,
          created_at: formatDateT(item.created_at),
          status:
            !item.horaEnvio || sendDate?.timestamp < now
              ? `<span style="color: #03182d; font-weight: 500">Enviado</span>`
              : `<div style="color:#dc3545; font-size: 16px"><div>Agendado (${sendDate.string})</div><div>`,
          messageRead: percMessageRead,
          messageSent: percMessageSent,
          messageReceived: percMessageReceived
        }
      })
      setTableConfig((prev) => ({
        ...prev,
        total: response?.data?.data?.campanhaNumber
      }))

      setRows(resume)
      setData(response?.data?.data)
      setLoading(false)
    } else {
      toast.error(response?.msg)
      setLoading(false)
      return false
    }
  }

  const loadInstancias = async () => {
    const response = await Services.loadInstancias()

    if (response.status === 200) {
      const data = []

      response?.data?.data?.data.map((item) => {
        data.push({
          label: item.name,
          value: item.id
        })
      })

      setInstanciasList(data)
    } else {
      toast.error(response?.msg)
      return false
    }
  }

  const handleClose = () => {
    setLoading(false)
  }

  const handlerInstancia = (instanceId) => {
    setTableConfig((prev) => ({
      ...prev,
      currentPage: 0,
      filters: {
        ...prev.filters,
        instanceId: instanceId ?? null
      }
    }))
  }

  const clearFilters = () => {
    setValueDatePicker({ startsAt: null, endsAt: null })
    setTableConfig((prev) => ({
      ...prev,
      currentPage: 0,
      filters: {
        ...prev.filters,
        instanceId: null,
        startsAt: null,
        endsAt: null
      }
    }))
  }

  function handleChangeDate(value, field) {
    if (!value) {
      setTableConfig((prev) => ({
        ...prev,
        currentPage: 0,
        filters: {
          ...prev.filters,
          [field]: null
        }
      }))
      setValueDatePicker((prev) => ({
        ...prev,
        [field]: null
      }))
      return
    }
    const formattedDate = format(value, 'yyyy-MM-dd')
    setTableConfig((prev) => ({
      ...prev,
      currentPage: 0,
      filters: {
        ...prev.filters,
        [field]: formattedDate
      }
    }))
    setValueDatePicker((prev) => ({
      ...prev,
      [field]: value
    }))
  }

  useEffect(() => {
    if (!rendered) {
      setRendered(true)
    }

    if (rendered) {
      loadInstancias()
      loadIndicators()
    }
  }, [rendered])

  useEffect(() => {
    if (!rendered) return
    loadIndicators()
  }, [tableConfig.currentPage, tableConfig.filters])

  return (
    <React.Fragment>
      {loading && <Loading open={loading} handleClose={handleClose} />}

      <div className="page-content">
        <MetaTags>
          <title>Dashboard | Zap+</title>
        </MetaTags>
        <Container fluid>
          <div className={styles.dashboardStack}>
            <PageHeader
              title="Dashboard | Zap+"
              subtitle="Resumo de instâncias, envios e taxas; use os filtros para refinar a tabela de campanhas."
            />

            <div>
              <h3 className={styles.kpiSectionTitle}>Indicadores</h3>
              <p className={styles.kpiSectionHint}>
                Totais considerando os filtros ativos (instância e período).
              </p>
              <Row>
                <CardIndicador
                  icon={'mdi mdi-cellphone'}
                  value={data?.instanciaNumber || 0}
                  type={'number'}
                  text={'WhatsApps cadastrados'}
                  color="primary"
                  tone="brand"
                  xl={3}
                  md={3}
                  xs={12}
                />
                <CardIndicador
                  icon={'mdi mdi-access-point'}
                  value={data?.messageSent || 0}
                  type={'number'}
                  text={'Mensagens enviadas'}
                  color="primary"
                  tone="brand"
                  xl={3}
                  md={3}
                  xs={12}
                />
                <CardIndicador
                  icon={'mdi mdi-send-check'}
                  value={
                    data?.messageTotal
                      ? `${(data?.messageTotal !== 0
                          ? (data?.messageReceived * 100) / data?.messageTotal
                          : 0
                        ).toFixed(2)}%`
                      : '0%'
                  }
                  type={'number'}
                  text={'Taxa de mensagens recebidas'}
                  color="primary"
                  tone="brand"
                  xl={3}
                  md={3}
                  xs={12}
                />
                <CardIndicador
                  icon={'mdi mdi-eye-check'}
                  value={
                    data?.messageTotal
                      ? `${(data?.messageTotal !== 0
                          ? (data?.messageRead * 100) / data?.messageTotal
                          : 0
                        ).toFixed(2)}%`
                      : '0%'
                  }
                  type={'number'}
                  text={'Taxa de mensagens lidas'}
                  color="primary"
                  tone="brand"
                  xl={3}
                  md={3}
                  xs={12}
                />
              </Row>
            </div>

            <SectionCard
              title="Filtros"
              subtitle="Instância e intervalo de datas aplicam na listagem abaixo."
            >
              <Row className="g-3 align-items-end">
                <Col xs={12} md={4} className={styles.formSelect}>
                  <Form.Group className="mb-0">
                    <Label for="dashboard-instancia">Instância</Label>
                    <SelectComponent
                      options={instanciasList}
                      value={
                        instanciasList.find(
                          (a) => a.value === tableConfig.filters.instanceId
                        ) ?? null
                      }
                      onChange={(opt) =>
                        handlerInstancia(opt?.value ?? null)
                      }
                      placeholder="Todas as instâncias"
                      isClearable
                    />
                  </Form.Group>
                </Col>
                <Col xs={12} md={3} className={styles.formSelect}>
                  <Form.Group className="mb-0">
                    <Label for="dashboard-data-inicial">Data inicial</Label>
                    <ReactDatePicker
                      id="dashboard-data-inicial"
                      className="form-control"
                      selected={valueDatePicker.startsAt}
                      placeholderText="Início"
                      isClearable
                      onChange={(date) => {
                        handleChangeDate(date, 'startsAt')
                      }}
                      dateFormat="dd/MM/yyyy"
                      locale="pt-BR"
                    />
                  </Form.Group>
                </Col>

                <Col xs={12} md={3} className={styles.formSelect}>
                  <Form.Group className="mb-0">
                    <Label for="dashboard-data-final">Data final</Label>
                    <ReactDatePicker
                      id="dashboard-data-final"
                      className="form-control"
                      selected={valueDatePicker.endsAt}
                      placeholderText="Fim"
                      isClearable
                      onChange={(date) => {
                        handleChangeDate(date, 'endsAt')
                      }}
                      dateFormat="dd/MM/yyyy"
                      locale="pt-BR"
                    />
                  </Form.Group>
                </Col>

                <Col xs={12} md={2} className={styles.filterActions}>
                  <Button
                    type="button"
                    variant="outline-secondary"
                    size="sm"
                    onClick={clearFilters}
                  >
                    Limpar filtros
                  </Button>
                </Col>
              </Row>
            </SectionCard>
          </div>
          <Row>
            <Col xl={12}>
              <DatatableTables
                title={'Campanhas'}
                columns={columns}
                rows={rows}
                tableConfig={tableConfig}
                setTableConfig={setTableConfig}
              />
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}

Dashboard.propTypes = {
  t: PropTypes.any
}

export default Dashboard
